<template>
  <div class="login-bgimg">
    <div class="login-main">
      <div class="login-box">
        <div class="sign-in">
          <img
            class="login-logo"
            src="@/assets/newlogin-pc.png"
            alt=""
          />
          <div class="login-tip">登录大河号，与更多人一起交流互动吧！</div>
          <div class="login-tabtitle">
            <span @click="loginTabClick(1)" :class="{ active: loginType == 1 }"
              >免密登录</span
            >
            <span @click="loginTabClick(0)" :class="{ active: loginType == 0 }"
              >密码登录</span
            >
          </div>
          <div class="login-input" v-if="loginType == 1">
            <el-form ref="form" :rules="rules" :model="form">
              <el-form-item prop="phone">
                <el-input
                  placeholder="手机号"
                  maxlength="11"
                  v-model.trim="form.phone"
                  @keyup.enter.native="login('form')"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item>
                <div class="phone-num">
                  <el-input
                    placeholder="图形验证码"
                    maxlength="4"
                    v-model.trim="verifyCode"
                  >
                  </el-input>
                  <img @click="fetchCaptcha" style="cursor:pointer;height:48px" :src="captchaSrc" alt="Captcha" />
                </div>
              </el-form-item>
              <el-form-item prop="sms">
                <div class="phone-num">
                  <el-input
                    placeholder="验证码"
                    maxlength="6"
                    v-model.trim="form.sms"
                    @keyup.enter.native="login('form')"
                    clearable
                    oninput="value=value.replace(/[^\d.]/g,'')"
                  >
                  </el-input>
                  <el-button
                    class="code-num"
                    :disabled="getsmsFlag"
                    @click="getsms('1')"
                    :loading="getsmsFlag"
                    >{{ btnsmsText }}</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="login-input" v-if="loginType == 0">
            <el-form ref="form" :rules="rules" :model="form">
              <el-form-item prop="username">
                <el-input
                  placeholder="用户名"
                  v-model.trim="form.username"
                  @keyup.enter.native="login('form')"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  placeholder="密码"
                  v-model.trim="form.password"
                  @keyup.enter.native="login('form')"
                  show-password
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="automatic-login" v-if="loginType == 0">
            <el-checkbox v-model="remmberMe">下次自动登录</el-checkbox>
          </div>
          <div class="login-btn">
            <el-button
              type="danger"
              @click="login('form')"
              round
              :loading="btnLoading"
              >{{ submitText }}</el-button
            >
          </div>
          <div class="agree-on">
            <el-checkbox v-model="checkedAgree">
              我已阅读并同意
              <a href="/agreement/0" target="_blank">用户协议</a>
              和
              <a href="/agreement/1" target="_blank">隐私政策</a>
            </el-checkbox>
          </div>
        </div>
        <!-- <div class="download-box" hidden>
          <span>下载大河号App</span>
          <div class="ewm-box">
            <img src="" alt="" />
          </div>
        </div> -->
      </div>
    </div>
    <div class="copyright-box">
      版权所有：<a href="" target="_blank">大河网</a>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="440px"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <div class="login-success">
        <img src="../assets/images/login-success.png" alt="" />
        <div class="login-title">恭喜你注册成功！</div>
        <div class="login-sum">
          完善个人信息会有更多志同道合的网友关注到你哦～
        </div>
        <div class="login-next">
          <el-button type="danger" @click="personSetting" round
            >立即完善</el-button
          >
          <el-button type="danger" @click="goHome" round>跳过</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisible2"
      width="440px"
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="login-success">
        <img src="../assets/images/login-bindphone.png" alt="" />
        <div class="login-title">当前帐号未绑定手机号</div>
        <div class="login-sum">绑定手机号，登录更便捷，提升账号安全性～</div>
        <div class="login-next">
          <el-button
            type="danger"
            @click="
              dialogVisible3 = true;
              dialogVisible2 = false;
            "
            round
            >立即绑定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="绑定手机号"
      :visible.sync="dialogVisible3"
      width="480px"
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="login-success">
        <div class="login-input">
          <el-form ref="form" :rules="rules" :model="form">
            <el-form-item prop="phone">
              <div class="phone-numbox">
                <el-input
                  placeholder="手机号"
                  v-model.trim="form.phone"
                  maxlength="11"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  clearable
                >
                </el-input>
              </div>
            </el-form-item>
            <el-form-item>
                <div class="phone-num">
                  <el-input
                    placeholder="图形验证码"
                    maxlength="4"
                    v-model.trim="verifyCode"
                  >
                  </el-input>
                  <img @click="fetchCaptcha" style="cursor:pointer;height:48px" :src="captchaSrc" alt="Captcha" />
                </div>
              </el-form-item>
            <el-form-item prop="sms">
              <div class="phone-num">
                <el-input
                  placeholder="验证码"
                  v-model.trim="form.sms"
                  maxlength="6"
                  clearable
                  oninput="value=value.replace(/[^\d.]/g,'')"
                >
                </el-input>
                <el-button
                  class="code-num"
                  :disabled="getsmsFlag"
                  @click="getsms('4')"
                  >{{ btnsmsText }}</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="login-next">
          <el-button type="danger" @click="bindPhone('form')" round
            >确定</el-button
          >
          <!-- <el-button type="danger" @click="dialogVisible3 = false" round
            >取消</el-button
          > -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import store from "@/store";
export default {
  name: "login",
  data() {
    let checkPhone = function (rule, value, callback) {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        var reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      remmberMe: localStorage.getItem("username") == "" && localStorage.getItem("password") == "" ? false : true,
      backUrl: this.$route.query.url ? this.$route.query.url : "",
      captchaSrc:'',
      verifyCode:'',
      uuid:'',
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      submitText: "注册/登录",
      btnsmsText: "获取验证码",
      timer: 60,
      getsmsFlag: false,
      btnLoading: false,
      loginType: 1,
      phonenum: "",
      phonecode: "",
      username: "",
      password: "",
      checked: false,
      checkedAgree: false,
      form: {
        phone: localStorage.getItem("phone") || "",
        sms: "",
        username: localStorage.getItem("username") || "",
        password: localStorage.getItem("password") || "",
      },
      rules: {
        phone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        sms: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      expireTime:12*60*60*1000
    };
  },
  created() {
    this.fetchCaptcha()
  },
  methods: {
    ...mapActions(["LOGIN", "GET_USERINFO"]),
    fetchCaptcha() {
      this.$api
            .codeImage({})
            .then((res) => {
              this.captchaSrc = 'data:image/png;base64,' + res.data.data.img;
              this.uuid = res.data.data.uuid;
            })
    },
    goHome() {
      if (this.backUrl) {
        this.$router.replace({ path: this.backUrl });
      } else {
        this.$router.replace({ path: "/" });
      }
    },
    handleClose() {
      if (this.backUrl) {
        this.$router.replace({ path: this.backUrl });
      } else {
        this.$router.replace({ path: "/" });
      }
    },
    personSetting() {
      this.$router.replace({ path: "/" });
    },
    loginTabClick(type) {
      this.loginType = type;
      this.submitText = this.loginType == 0 ? "注册/登录" : "立即登录";
    },
    bindPhone(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api
            .bindePhone({
              phone: this.form.phone,
              smsCode: this.form.sms,
              userName: this.form.username,
            })
            .then((res) => {
              localStorage.setItem(
                "phone",
                this.remmberMe == true ? this.form.phone : ""
              );
              localStorage.setItem("UserToken", res.data.data.token);
              localStorage.setItem(
                "UserInfo",
                JSON.stringify(res.data.data.user)
              );
              localStorage.setItem('key-expire', ((new Date()).valueOf() + this.expireTime));
              if (this.backUrl) {
                this.$router.replace({ path: this.backUrl });
              } else {
                this.$router.replace({ path: "/" });
              }
            });
        }
      });
    },
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checkedAgree) {
            this.btnLoading = true;
            this.LOGIN({
              type: this.loginType,
              username:
                this.loginType == 1 ? this.form.phone : this.form.username,
              password:
                this.loginType == 1 ? this.form.sms : this.form.password,
            })
              .then((res) => {
                //请求用户信息
                this.GET_USERINFO()
                  .then(() => {
                    if (res.data.data.user.firstRegister) {
                      this.dialogVisible = true;
                    } else {
                      if (this.backUrl) {
                        this.$router.replace({ path: this.backUrl });
                      } else {
                        this.$router.replace({ path: "/" });
                      }
                    }
                    localStorage.setItem(
                      "phone",
                      this.remmberMe == true ? this.form.phone : ""
                    );
                    localStorage.setItem(
                      "username",
                      this.remmberMe == true ? this.form.username : ""
                    );
                    localStorage.setItem(
                      "password",
                      this.remmberMe == true ? this.form.password : ""
                    );
                    localStorage.setItem('key-expire', ((new Date()).valueOf() + this.expireTime));
                    this.btnLoading = false;
                  })
                  .catch(() => {
                    this.btnLoading = false;
                  });
              })
              .catch((error) => {
                if (error.data.code == 1003) {
                  this.dialogVisible2 = true;
                }
                this.btnLoading = false;
              });
          } else {
            this.$message.error("请阅读并同意大河网协议和隐私政策");
            return false;
          }
        } else {
          this.$message.error("请输入正确信息！");
          return false;
        }
      });
    },
    // 获取验证码
    getsms(type) {
      if (this.form.phone.length !== 11) {
        this.$message({
          message: "请输入正确的手机号！",
          type: "error",
        });
        return false;
      }
      if (!this.verifyCode) {
        this.$message({
          message: "请输入图形验证码！",
          type: "error",
        });
        return false;
      }
      this.getsmsFlag = true;
      this.$api
        .sms({
          phone: this.form.phone,
          uuid:this.uuid,
          verifyCode:this.verifyCode,
          type: type,
        })
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.djs = setInterval(() => {
            if (this.timer == 0) {
              this.timer = 60;
              this.btnsmsText = "重新发送";
              this.getsmsFlag = false;
              clearInterval(this.djs);
            } else {
              this.timer--;
              this.btnsmsText = this.timer + "s重新发送";
              this.getsmsFlag = true;
            }
          }, 1000);
        })
        .catch(() => {
          this.getsmsFlag = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-bgimg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url("../assets/images/login-bg-btm.png") center bottom no-repeat,
              url("../assets/images/login-bgimg.png") no-repeat center center;
  background-size: contain,cover;
  min-width: 1000px;
  .login-main{
    width: 1000px;
    position: relative;
    height: 100%;
    margin: 0 auto;
  }
  .login-box {
    width: 441px;
    height: auto;
    background: #ffffff;
    border-radius: 4px;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -300px;
    z-index: 111;
    /deep/ .sign-in {
      width: 100%;
      padding: 54px 51px 40px;
      .login-logo {
        width: auto;
        height: 42px;
      }
      .login-tip {
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
        margin-top: 10px;
      }
      .login-tabtitle {
        width: 100%;
        height: 60px;
        border-bottom: 1px solid #efefef;
        display: flex;
        span {
          height: 57px;
          color: #666666;
          font-size: 18px;
          font-weight: 400;
          line-height: 66px;
          margin-right: 50px;
          cursor: pointer;
        }
        .active {
          font-weight: bold;
          color: #121212;
          border-bottom: 3px solid #317DFF;
        }
      }
      .login-input {
        width: 100%;
        margin-top: 20px;
        .phone-num {
          width: 100%;
          display: flex;
          height: 48px;
          border-radius: 3px;
          background: #f5f5f5;
          //   margin-top: 16px;
          .el-input {
            margin-top: 0;
            width: 240px;
          }
          .code-num {
            width: 100px;
            height: 48px;
            line-height: 48px;
            font-size: 14px;
            color: #333333;
            text-align: center;
            border: none;
            padding: 0;
            background: transparent;
          }
        }
        .el-input {
          height: 48px;
          //   margin-top: 16px;
          .el-input__inner {
            height: 48px;
            border-radius: 3px;

            background: #f5f5f5;
            border: none;
          }
          .el-input__suffix {
            height: 100%;
          }
        }
      }
      .automatic-login {
        margin-top: 10px;
      }
      .is-checked {
        .el-checkbox__inner {
          background: #317DFF;
          border-color: #317DFF;
          &:hover {
            border-color: #317DFF;
          }
        }

        .el-checkbox__label {
          color: #606266;
          a {
            color: #317DFF;
          }
        }
      }
      .is-focus {
        .el-checkbox__inner {
          border-color: #317DFF;
        }
      }
      .login-btn {
        width: 340px;
        height: 48px;
        margin-top: 18px;
        .el-button {
          width: 100%;
          height: 100%;
          background: #317DFF;
          border-radius: 3px;
          font-size: 16px;
          color: #ffffff;
        }
      }
      .agree-on {
        width: 100%;
        margin-top: 10px;
        a {
          color: #317DFF;
        }
      }
    }
    .download-box {
      width: 100%;
      height: 67px;
      background: #fafafa;
      border-radius: 0px 0px 4px 4px;
      text-align: center;
      line-height: 67px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      span {
        display: block;
        width: 160px;
        height: 30px;
        line-height: 30px;
        background: url("../assets/images/img/logo-icon.png") no-repeat left
          center;
        padding-left: 20px;
        cursor: pointer;
      }
      .ewm-box {
        display: none;
        width: 120px;
        height: 128px;
        background: url("../assets/images/icon/ewm-box.png") no-repeat left
          center;
        position: absolute;
        left: 85px;
        top: 65px;
        text-align: center;
        img {
          width: 92px;
          height: 95px;
          margin-top: 20px;
        }
      }
      &:hover {
        .ewm-box {
          display: block;
        }
      }
    }
  }
  .copyright-box {
    width: 100%;
    height: 40px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    position: absolute;
    bottom: 20px;
    text-align: center;
    a {
      color: #ffffff;
    }
  }
  /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
    .el-dialog__body {
      padding: 0;
      .login-success {
        width: 100%;
        padding: 10px 70px 50px;
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
          width: 72px;
          height: 72px;
        }
        .login-title {
          font-size: 18px;
          font-weight: 600;
          color: #121212;
          margin-top: 15px;
        }
        .login-sum {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          text-align: center;
          line-height: 22px;
          margin-top: 20px;
        }
        .login-input {
          width: 100%;
          .phone-num {
            width: 100%;
            display: flex;
            height: 48px;
            border-radius: 3px;
            background: #ffffff;
            // margin-top: 16px;
            border: 1px solid #e5e5e5;
            .el-input {
              margin-top: 0;
              width: 240px;
            }
            .code-num {
              width: 100px;
              height: 48px;
              line-height: 48px;
              font-size: 14px;
              color: #317DFF;
              text-align: center;
              border: none;
              padding: 0;
              background: transparent;
            }
          }
          .phone-numbox {
            width: 100%;
            display: flex;
            height: 48px;
            border-radius: 3px;
            background: #ffffff;
            margin-top: 16px;
            border: 1px solid #e5e5e5;
            .el-input {
              margin-top: 0;
            }
          }
          .el-input {
            height: 46px;
            margin-top: 16px;
            .el-input__inner {
              height: 46px;
              border-radius: 3px;
              background: #ffffff;
              border: none;
            }
            .el-input__suffix {
              height: 100%;
            }
          }
        }
        .login-next {
          width: 100%;
          margin-top: 30px;
          display: flex;
          justify-content: space-around;
          .el-button {
            width: 128px;
            height: 40px;
            background: #317DFF;
            border-radius: 4px;
            font-size: 15px;
            color: #ffffff;
          }
          .el-button:nth-child(2) {
            background: #dddddd;
            border-radius: 4px;
            border: 1px solid #dddddd;
            color: #2f2f2f;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue